import {NgModule}                    from '@angular/core';
import {CommonModule}                from '@angular/common';
import {ApDynComponentModule}        from '../../ap-dyncomponent/ap-dyncomponent.module';
import {ApStatisticsModule}          from '../../statistics/ap-statistics.module';
import {ApResponsiveTextModule}      from '../../ap-responsive-text/ap-responsive-text.module';
import {ApCoreModule}                from '../../ap-core/ap-core.module';
import {ButtonModule}                from '@progress/kendo-angular-buttons';
import {FwPlanPlanningComponent}     from './fw-plan-planning.component';
import {FwPlanBookingComponent}      from './fw-plan-booking.component';
import {FwEntryComponentsService}    from './services/fw-entry-components.service';
import {FwPlanShowComponent}         from './fw-plan-show.component';
import {ApTranslationModule}         from '../../translation/ap-translation.module';
import {FwPlanPlanningSelectionProvider} from './plan-planning/providers/fw-plan-planning-selection.provider';
import {FwPlanPlanningDetailsProvider} from './plan-planning/providers/fw-plan-planning-details.provider';
import {FwPlanPlanningOverviewProvider} from './plan-planning/providers/fw-plan-planning-overview.provider';
import {FwPlanPlanningCommonConfig} from './plan-planning/configs/fw-plan-planning-common.config';
import {FwPlanPlanningSelectionConfig} from './plan-planning/configs/fw-plan-planning-selection.config';
import {FwPlanPlanningDetailsConfig} from './plan-planning/configs/fw-plan-planning-details.config';
import {FwPlanPlanningOverviewConfig} from './plan-planning/configs/fw-plan-planning-overview.config';
import {ApSingleClickDirective} from '../../ap-utils/directives/ap-single-click.directive';

@NgModule({
  declarations: [
    FwPlanShowComponent,
    FwPlanPlanningComponent,
    FwPlanBookingComponent
  ],
  imports: [
    CommonModule,
    ApDynComponentModule,
    ApStatisticsModule,
    ApResponsiveTextModule,
    ApCoreModule,
    ButtonModule,
    ApTranslationModule,
    ApSingleClickDirective
  ],
  providers: [
    FwEntryComponentsService,
    FwPlanPlanningSelectionProvider,
    FwPlanPlanningDetailsProvider,
    FwPlanPlanningOverviewProvider,
    FwPlanPlanningCommonConfig,
    FwPlanPlanningSelectionConfig,
    FwPlanPlanningDetailsConfig,
    FwPlanPlanningOverviewConfig
  ]
})
export class FwEntryComponentsModule {
}
